import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  CircularProgress,
  Typography,
  useTheme,
} from '@mui/material';
import FavoritesForm from './FavoritesForm';

const HotelFavoritesDialog = ({
  showModalFavoritos,
  setShowModalFavoritos,
  isLoading,
  isShowAlert,
  alertOptions = {},
  favMessage,
  handleFavMessage,
  fav_messages,
  setIsShowAlert,
  setIsLoading,
  hotReferenceCities,
  user,
  hotel,
  setAlertOptions,
  sites,
  isAdmin,
}) => {
  const theme = useTheme();

  const handleClose = () => {
    setShowModalFavoritos(false);
    setIsShowAlert(false);
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <Grid container justifyContent="center">
          <CircularProgress color="primary" />
        </Grid>
      );
    }

    if (isShowAlert) {
      let textColor;
      switch (alertOptions.type) {
        case 'error':
          textColor = 'error.main';
          break;
        case 'warning':
          textColor = 'warning.dark';
          break;
        case 'success':
        default:
          textColor = 'success.main';
          break;
      }

      return (
        <Typography
          variant="body1"
          color={textColor}
          sx={{ textAlign: 'center', fontWeight: 500, my: 2, px: 2 }}
        >
          {alertOptions.msg}
        </Typography>
      );
    }

    return (
      <FavoritesForm
        hotel={hotel}
        user={user}
        favMessage={favMessage}
        handleFavMessage={handleFavMessage}
        fav_messages={fav_messages}
        sites={sites}
        isAdmin={isAdmin}
        hotReferenceCities={hotReferenceCities}
        setIsLoading={setIsLoading}
        setIsShowAlert={setIsShowAlert}
        setAlertOptions={setAlertOptions}
        setShowModalFavoritos={setShowModalFavoritos}
        handleClose={handleClose}
      />
    );
  };

  return (
    <Dialog
      open={showModalFavoritos}
      disableRestoreFocus
      onClose={handleClose}
      aria-labelledby="favorites-dialog-title"
      aria-describedby="favorites-dialog-description"
    >
      <DialogTitle id="favorites-dialog-title">
        Agregar &quot;{hotel.name}&quot; a favoritos
      </DialogTitle>

      <DialogContent dividers>{renderContent()}</DialogContent>

      {!isLoading && isShowAlert && (
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              backgroundColor: theme.primary,
              color: theme.text1,
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default HotelFavoritesDialog;
